export var Weight;
(function (Weight) {
    Weight["BOLD"] = "bold";
    Weight["NORMAL"] = "normal";
    Weight["LIGHTER"] = "lighter";
})(Weight || (Weight = {}));
var Text = /** @class */ (function () {
    function Text(text, x, y, size, color, weight) {
        this.x = x;
        this.y = y;
        this.text = text;
        this.size = size || 24;
        this.weight = weight || Weight.NORMAL;
        this.color = color || '#000000';
    }
    Text.prototype.drawCanvas = function (ctx) {
        ctx.save();
        ctx.scale(1, -1);
        ctx.textAlign = 'center';
        ctx.font = this.weight + " " + this.size + "px Times New Roman";
        ctx.fillStyle = this.color || '#000000';
        ctx.fillText(this.text, this.x, this.y);
        ctx.restore();
    };
    return Text;
}());
export default Text;
//# sourceMappingURL=text.js.map